import { apiClient } from '@/services/ApiClient.js'

export default {
  download(type) {
    return apiClient
      .post('download-import-template', { type: type }, { responseType: 'arraybuffer' })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
